import styled, { css } from 'styled-components';

export const FullReportContainer = styled.div`
  .section-box {
    margin-bottom: 8px;
  }

  .actions {
    margin-top: 36px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 500px) {
      flex-direction: column;

      .button {
        margin-bottom: 12px;
      }
    }
  }
`;

export const Table = styled.table`
  width: 100%;
  font-size: 14px;
  border: 1px solid #f1f1f1;
  box-sizing: border-box;
  border-radius: 0 0 6px 6px;
  padding: 12px 16px 4px 16px;

  tr:first-child.fake-hide {
    position: absolute;
  }

  tr:first-child td {
    padding-top: 0;
  }

  tr td:first-child {
    @media (max-width: 500px) {
      padding-bottom: 4px;
    }
  }

  .items {
    display: flex;
    flex-direction: column;

    span {
      padding-bottom: 10px;
    }
  }
`;

export const TR = styled.tr`
  @media (max-width: 500px) {
    display: flex;
    flex-direction: column;
  }

  td {
    padding-bottom: 10px;
    vertical-align: baseline;
  }

  td:first-child {
    width: 200px;
  }

  .gray {
    color: #8c969d;
  }

  .is-invalid {
    color: #d0021b;
  }

  .is-invalid-opacity {
    color: #d0021b;
    opacity: 0.5;
  }

  //.setPadding {
  //  padding-top: 14px;
  //}

  .hidden {
    font-size: 0;
  }
`;
